import i18n from 'i18n';
import { CreateRecyclingConsignmentOrderV2SchemaType } from '../../common';
import {
  Control,
  Controller,
  UseFormSetValue,
  useWatch,
} from 'react-hook-form';
import { FormLabel } from '../../form-label';
import LOCALS from 'commons/locals';
import { Cascader } from 'antd';
import { useMaterialCascaderOptionsByFirstLevelCategoryId } from 'pages/product/create-page-v2/common';
import { useCallback } from 'react';
import { DefaultOptionType } from 'types/base';
import getCascaderFilter from 'utils/getCascaderFilter';

const Material = ({
  control,
  index,
  setValue,
  required,
}: {
  control: Control<CreateRecyclingConsignmentOrderV2SchemaType>;
  index: number;
  setValue: UseFormSetValue<CreateRecyclingConsignmentOrderV2SchemaType>;
  required?: boolean;
}) => {
  const productCategoryIdList = useWatch({
    control,
    name: `productList.${index}.productCategoryIdList`,
  });
  const firstLevelId = productCategoryIdList[0];

  const { materialCascaderOptions } =
    useMaterialCascaderOptionsByFirstLevelCategoryId(firstLevelId);
  const CascaderFilter = useCallback(
    (inputValue: string, path: DefaultOptionType[]) =>
      getCascaderFilter(inputValue, path),
    []
  );

  return (
    <div className="flex items-center gap-2">
      <FormLabel required={required}>{i18n.t(LOCALS.material)}:</FormLabel>
      <Controller
        name={`productList.${index}.material`}
        control={control}
        render={({ field, formState: { errors } }) => {
          return (
            <Cascader
              {...field}
              className="w-full"
              status={errors.productList?.[index]?.material ? 'error' : undefined}
              showSearch={{ filter: CascaderFilter }}
              options={materialCascaderOptions}
              multiple
              placeholder={
                firstLevelId
                  ? i18n.t(LOCALS.please_select)
                  : i18n.t(LOCALS.please_select_category_first)
              }
              onChange={(value) => {
                field.onChange(value);

                const material = value.map((d) => d.map((d) => d.toString()));
                const flatMaterial = material.flat();

                // 包含稀有皮材质则禁用facebook
                setValue(
                  `productList.${index}.facebookEnabled`,
                  flatMaterial.length
                    ? flatMaterial.includes('exotic-skin')
                      ? 0
                      : 1
                    : 0
                );
              }}
            />
          );
        }}
      />
    </div>
  );
};

export default Material;
